import { Skeleton } from "@mui/material";
import Stack from "@mui/material/Stack";

const OrganizationMenuSkeleton = () => {
    return (
        <Stack>
            <Skeleton variant="text" width={300} height={40} />
            <Skeleton variant="text" width={150} />
            <Stack direction="row" justifyContent="flex-end">
                <Skeleton variant="text" height={40} width={50} />
            </Stack>
        </Stack>
    )
}

export default OrganizationMenuSkeleton;
